module.exports = __webpack_public_path__ + "static/uniswap-8d5bfdc9ec62ef9899b586c868cb9fd9.webp";